<template>
    <div class="d-flex align-center">
        <v-btn @click="check" color="primary" small>
            <v-icon left>mdi-check</v-icon>
            cek kesamaan lokal
        </v-btn>

        <similarity-alert :is-passed="isPassed" />
    </div>
</template>

<script>
const QUESTION_CHARACTER_CHECK_TRESHOLD = 100
import SimilarityAlert from './SimilarityAlert.vue'

export default {
    props: {
        tryouts: {
            type: Array,
            required: true
        }
    },

    components: {
        SimilarityAlert
    },

    data: () => ({
        isPassed: null
    }),

    methods: {
        check() {
            const similiarityCheck = (
                checkedQuestion,
                checkedQuestionIdx,
                checkedTryoutIdx
            ) => {
                const result = []
                for (const tryoutIdx in this.tryouts) {
                    const tryout = this.tryouts[tryoutIdx]

                    for (const questionIdx in tryout.questions) {
                        const question = tryout.questions[questionIdx]

                        // prettier-ignore
                        if (
                            ! (checkedQuestionIdx == questionIdx && checkedTryoutIdx == tryoutIdx)
                            && (
                                checkedQuestion.id == question.id
                                || question.question.substring(1, QUESTION_CHARACTER_CHECK_TRESHOLD) == checkedQuestion.question.substring(1, QUESTION_CHARACTER_CHECK_TRESHOLD)
                            )
                        ) {
                            result.push({
                                question: question.question,
                                localOccurence: {
                                    tryoutIdx,
                                    questionIdx
                                }
                            })
                        }
                    }
                }

                return result
            }

            const result = {}
            let isSimiliarityExists = false
            for (const tryoutIdx in this.tryouts) {
                const tryout = this.tryouts[tryoutIdx]

                for (const questionIdx in tryout.questions) {
                    const question = tryout.questions[questionIdx]
                    const similiarityResult = similiarityCheck(
                        question,
                        questionIdx,
                        tryoutIdx
                    )

                    if (similiarityResult.length == 0) {
                        continue
                    }
                    isSimiliarityExists = true

                    if (result[tryoutIdx] === undefined) {
                        result[tryoutIdx] = {}
                    }

                    if (result[tryoutIdx][questionIdx] === undefined) {
                        result[tryoutIdx][questionIdx] = []
                    }

                    // prettier-ignore
                    result[tryoutIdx][questionIdx] = result[tryoutIdx][questionIdx]
                        .concat(similiarityResult)
                }
            }

            this.isPassed = !isSimiliarityExists
            this.$emit('input', isSimiliarityExists ? result : null)
        }
    }
}
</script>
